module.exports = __webpack_public_path__ + "/assets/img/32827f90edd41aeeacc83ec7280c6803.png";